import { useRef } from 'react';
import { FormattedMessage } from 'react-intl';

import { getLinkAriaLabel } from '@/utils/urlUtils';

import LinkWithLocale from '@/components/LinkWithLocale/LinkWithLocale';
import { useRouter } from '@/hooks/useRouter';
import { useRegionProvider } from '@/providers/RegionProvider';
import { searchStateActions } from '@/states/searchState';

import * as S from './Navigation.styles';

export interface NavItem {
  id: string;
  label: string;
  url: string;
}

export interface NavigationProps {
  isShrunk?: boolean;
  navItems: NavItem[];
  textColorOption?: string;
}

export const Navigation = ({
  isShrunk = false,
  navItems,
  textColorOption = 'dark',
}: NavigationProps) => {
  const { paths } = useRouter();
  const hrefUrl = paths.url();
  const navRef = useRef<HTMLElement | null>(null);
  const currentURL = useRouter().asPath;
  const { locale } = useRegionProvider();

  return (
    <S.Nav
      ref={navRef}
      $isShrunk={isShrunk}
      $textColorOption={textColorOption}
      data-test-id='Navigation'
      onClick={() => searchStateActions.changeOverlayStatus('CLOSE')}
    >
      <ul data-test-id='NavigationList'>
        {navItems?.map((navItem, index) => (
          <li key={navItem.id}>
            <S.Item
              $isActive={navItem.url === '/' + currentURL.split('/')[1]}
              data-test-id={`NavigationItem-${index}`}
            >
              <LinkWithLocale
                href={navItem.url || hrefUrl}
                aria-label={
                  getLinkAriaLabel(navItem.url, locale.code) || navItem.label
                }
              >
                <FormattedMessage
                  data-test-id={`NavigationLink-${index}`}
                  defaultMessage={navItem.label}
                  id={navItem.id}
                />
              </LinkWithLocale>
            </S.Item>
          </li>
        ))}
      </ul>
    </S.Nav>
  );
};

Navigation.displayName = 'Navigation';
